// extracted by mini-css-extract-plugin
export var alignCenter = "_85-d";
export var bannerShown = "_85-6";
export var buttonContent = "_85-0";
export var cardList = "_85-1";
export var centerContent = "_85-2";
export var chevron = "_85-3";
export var closePanelButton = "_85-k";
export var conversationContextContainer = "_85-l";
export var conversationDetailContainer = "_85-4";
export var detailWrapper = "_85-7";
export var dropdownButton = "_85-e";
export var dropdownTitle = "_85-9";
export var fullHeight = "_85-5";
export var hidden = "_85-a";
export var icon = "_85-b";
export var mergeSuggestionWrapper = "_85-m";
export var panel = "_85-i";
export var portalButtonsWrapper = "_85-c";
export var right = "_85-j";
export var tableSummaryContainer = "_85-8";
export var tableSummaryHeader = "_85-g";
export var threeDotsButton = "_85-f";
export var wide = "_85-h";